/// TYPES ///
import { FilterEndCustomer } from "api/types/customer";
/// URLS ///
import { url_prefix } from "settings";
import { end_customer_url } from "../../../endpoint";

export function constructGetEndCustomerUrl(args: FilterEndCustomer): string {
  let url = `${url_prefix}${end_customer_url}/?`;

  if (args) {
    if (args.first_name && args.first_name !== "") {
      url += `first_name=${args.first_name}&`;
    }
    if (args.last_name && args.last_name !== "") {
      url += `last_name=${args.last_name}&`;
    }
    if (args.business_name && args.business_name !== "") {
      url += `business_name=${args.business_name}&`;
    }
    if (args.address && args.address !== "") {
      url += `address=${args.address}&`;
    }
    if (args.city && args.city !== "") {
      url += `city=${args.city}&`;
    }
    if (args.province && args.province !== "") {
      url += `province=${args.province}&`;
    }
    if (args.email && args.email !== "") {
      url += `email=${args.email}&`;
    }
    if (args.phone && args.phone !== "") {
      url += `phone_number=${args.phone}&`;
    }
    if (args.postal && args.postal !== "") {
      url += `postal=${args.postal}&`;
    }
    if (args.any) {
      url += "any=true&";
    }
    if (args.limit) {
      url += `limit=${args.limit}&`;
    }
  }

  return url;
}
